import React from "react";
import Setting from "../../../assets/images/setting-4.png";

const MaxBetModal = ({ isOpen, setOpen, maxBet }) => {
  console.log(isOpen, maxBet)
  if (!isOpen) return null;


  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-gray-800 p-3 p-sm-3 p-md-6 p-lg-6 w-1/3 rounded-lg shadow-lg  ">
        <div className="w-full justify-content-between d-flex rounded">

          <p className="text-sm text-white mb-0 font-semibold d-flex rounded ">
          <img src={Setting} className="coin-img me-2 " alt="setting" />
            Max bet</p>
          <button
            className=" text-gray-500 hover:text-gray-800"
            onClick={() => {
              setOpen((prev) => ({...prev, open: !isOpen }));
            }}
          >
            ✖
          </button>
        </div>

        <div>
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <p className="text-white my-3">Are you sure you want to enable the max bet button?</p>
           <div className="cursor-pointer p-2 yellow-title w-sm-1/2 w-md-1/3 m-auto text-center rounded font-semibold"
           onClick={() => {

            setOpen((prev) => ({...prev, enable: true, open: false}))
           }}
           >Enable</div>
          
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaxBetModal;
